import { __assign, __rest } from "tslib";
import * as React from 'react';
var KvikaNoText = function (_a) {
    var title = _a.title, titleId = _a.titleId, _b = _a.width, width = _b === void 0 ? 225 : _b, props = __rest(_a, ["title", "titleId", "width"]);
    return (React.createElement("svg", __assign({ width: width, fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50.2 87.9h12.6V66.6l-12.6-8.1v29.4ZM25.1 75.4h12.6V50.1l-12.6-8.2v33.5ZM0 62.8h12.6V33.5L0 25.2v37.6ZM12.6 12.6v20.9l12.5 8.4V12.6H12.6ZM63 13v54l12.6 8.5V13H63ZM37.7 0v50.1l12.5 8.4V0H37.7Z", fill: "#A28352" })));
};
export default KvikaNoText;
//# sourceMappingURL=KvikaNoText.js.map